import {EmailSubscriptions_EmailSubscription} from '../../../grpc_client/grips/protos/email_subscriptions/v1/email_subscription';
import {DropSection} from '../../../grpc_client/grips/protos/pages/v1/drop_section';
import {Drop} from '../../../grpc_client/grips/protos/shared/drop';
import {DropCasesEnum} from '../types';

export function getDropsByType(
  drops: DropSection[] | undefined,
  type: DropCasesEnum,
): Drop[] | Drop {
  if (!drops) {
    return [];
  }

  const dropSelector =
    type === DropCasesEnum.LAST_CHANCE_DROP ? 'drop' : 'drops';

  return (
    drops
      ?.filter((drop: DropSection) => drop.type?.$case === type)
      // eslint-disable-next-line
      // @ts-ignore
      ?.map((drop: DropSection) => drop?.type[type]?.[dropSelector])
      ?.flat()
  );
}

export function filterOnlySubscribedDropTypes(
  subscriptions?: EmailSubscriptions_EmailSubscription[],
) {
  if (!subscriptions) {
    return [];
  }
  return subscriptions
    .filter(({isSelected}) => !!isSelected)
    .map(({type}) => type);
}
